/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Stat_UptimeInputs */

const en_landing_preview_stat_uptime = /** @type {(inputs: Landing_Preview_Stat_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uptime`)
};

/**
* | output |
* | --- |
* | "Uptime" |
*
* @param {Landing_Preview_Stat_UptimeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_stat_uptime = /** @type {((inputs?: Landing_Preview_Stat_UptimeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Stat_UptimeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_stat_uptime(inputs)
});